// extracted by mini-css-extract-plugin
module.exports = {"container":"avatarUpload_container__1xq65"};